import { Action, createReducer, on } from '@ngrx/store';
import {
    loadContractsForCandidateFailure,
    loadContractsForCandidateSuccess,
    resetContracts
} from 'src/app/compliance/store/actions/contract.actions';
import { ComplianceContractsState } from 'src/app/compliance/store/state/compliance-contracts.state';

const initialState: ComplianceContractsState = {
    contracts: []
};

const reducer = createReducer(
    initialState,

    on(loadContractsForCandidateSuccess, (state, action) => ({
        ...state,
        contracts: action.contracts
    })),

    on(loadContractsForCandidateFailure, (state, action) => ({
        ...state,
        contracts: []
    })),

    on(resetContracts, (state, action) => ({
        ...state,
        contracts: []
    }))
);

export function contractsReducer(state: ComplianceContractsState | undefined, action: Action) {
    return reducer(state, action);
}
